import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	LogResultDocument,
	SurtidoTiendasSliceTypes,
	SurtidoTiendasPayloadAction,
	REPLENISHMENT_TYPES
} from '@/features/inventoryAssortment/types/SurtidoTiendas.types'
import { format } from 'date-fns'

const fechaVenta = new Date()
fechaVenta.setDate(fechaVenta.getDate() - 1)
const date2 = new Date()

const initialState: SurtidoTiendasSliceTypes = {
	data: [],
	logDocs: [],
	step: 0,
	Base: REPLENISHMENT_TYPES.SYNC_FLOW,
	Segmentos: ['ACCESORIOS'],
	FechaVenta: fechaVenta,
	Plaza: 0,
	Tiendas: [],
	FechaConta: date2,
	FechaDoc: date2,
	ListaPrecios: 1,
	Comentario: `Reposición de Mercancia Corr. venta del dia ${format(fechaVenta, 'dd/MM/yyyy')}`,
	UserSAP: '',
	PwdSAP: '',
	penetracionBuffer: false
}

export const surtidoTiendasSlice = createSlice({
	name: 'surtidoTiendas',
	initialState,
	reducers: {
		setSurtidoTiendasData: (state, action: PayloadAction<SurtidoTiendasPayloadAction>) => ({
			...state,
			...action.payload
		}),
		resetSurtidoTiendasData: () => initialState,
		changeStep: (state, action: PayloadAction<number>) => ({
			...state,
			step: action.payload
		}),
		addDocLog: (state, action: PayloadAction<LogResultDocument>) => ({
			...state,
			logDocs: [...state.logDocs, action.payload]
		}),
		setPenetracionBuffer: (state, action: PayloadAction<boolean>) => ({
			...state,
			penetracionBuffer: action.payload
		})
	}
})

export const {
	setSurtidoTiendasData,
	resetSurtidoTiendasData,
	changeStep,
	addDocLog,
	setPenetracionBuffer
} = surtidoTiendasSlice.actions
export default surtidoTiendasSlice
